/**
 * Hook: Dock position — bottom/top/left/right
 * Persisted in localStorage + cross-component sync via custom event
 */
import { useEffect, useState } from 'react'

export type DockPosition = 'bottom' | 'top' | 'left' | 'right'

const EVENT = 'runai:dock-position'

export function useDockPosition() {
  const [position, setPosition] = useState<DockPosition>(() => {
    return (localStorage.getItem('dock-position') as DockPosition) ?? 'bottom'
  })

  useEffect(() => {
    const onChange = (e: Event) => {
      const detail = (e as CustomEvent).detail as DockPosition
      if (detail) setPosition(detail)
    }
    window.addEventListener(EVENT, onChange)
    return () => window.removeEventListener(EVENT, onChange)
  }, [])

  const setPos = (pos: DockPosition) => {
    localStorage.setItem('dock-position', pos)
    setPosition(pos)
    window.dispatchEvent(new CustomEvent(EVENT, { detail: pos }))
  }

  const isHorizontal = position === 'bottom' || position === 'top'

  return { position, setPos, isHorizontal }
}
